import React from 'react';
import { cn } from '../../utils/cn';

export interface ProgressBarProps {
  value: number;
  max?: number;
  variant?: 'primary' | 'success' | 'warning';
  showLabel?: boolean;
  className?: string;
}

const fillColors: Record<string, string> = {
  primary: 'bg-[var(--primary-500)]',
  success: 'bg-[var(--green-500)]',
  warning: 'bg-[var(--coral-500)]',
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  variant = 'primary',
  showLabel = false,
  className,
}) => {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));

  return (
    <div className={cn('w-full', className)}>
      {showLabel && (
        <div className="flex justify-end mb-1">
          <span className="text-xs font-medium text-[var(--muted-foreground)]">{Math.round(pct)}%</span>
        </div>
      )}
      <div className="w-full h-2 bg-[var(--muted)] rounded" role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max}>
        <div
          className={cn('h-full rounded transition-all duration-300', fillColors[variant])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
